import { useState } from 'react';
import { Button, Checkbox, Modal } from 'antd';
import { defaultPicked } from '../lib/printDocs';

// "Print which documents?" — shown by Print / PDF when the copy holds more than one
// document (an OTP / OTR with its Inventory List and LOU). See lib/printDocs.js.
// The LOU starts unticked and is numbered only when it is actually printed.
export default function PrintDocsPicker({ open, docs, onCancel, onPrint }) {
  // The choice lives in the body, which destroyOnHidden remounts on every open — so
  // each Print starts again from the default (LOU unticked).
  return (
    <Modal open={open} title="Print which documents?" onCancel={onCancel} centered destroyOnHidden footer={null}>
      <PickerBody docs={docs} onCancel={onCancel} onPrint={onPrint} />
    </Modal>
  );
}

function PickerBody({ docs, onCancel, onPrint }) {
  const [picked, setPicked] = useState(() => defaultPicked(docs));
  return (
    <>
      <Checkbox.Group value={picked} onChange={setPicked} style={{ display: 'flex', flexDirection: 'column', gap: 12, padding: '4px 0' }}>
        {docs.map((d) => (
          <Checkbox key={d.key} value={d.key}>
            <div style={{ fontSize: 14, fontWeight: 500 }}>{d.title}</div>
            <div style={{ fontSize: 12, color: 'var(--muted, #888)' }}>
              {d.ref || (d.key === 'lou' ? 'Numbered when printed or sent for signing, once the agreement is complete' : d.key === 'inventory' ? 'Signed with the agreement' : '')}
            </div>
          </Checkbox>
        ))}
      </Checkbox.Group>
      {/* Only when there is an LOU to leave out (it is switchable per agreement). */}
      {docs.some((d) => d.key === 'lou') && (
        <div style={{ marginTop: 12, fontSize: 12, color: 'var(--muted, #888)', lineHeight: 1.5 }}>
          The Letter of Undertaking shows CID&apos;s fee to the owner. Leave it out of the copy for the buyer or tenant.
        </div>
      )}
      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 16 }}>
        <Button onClick={onCancel}>Cancel</Button>
        <Button type="primary" disabled={!picked.length} onClick={() => onPrint(picked)}>Print</Button>
      </div>
    </>
  );
}
